module.exports = __webpack_public_path__ + "media/images/dog_200-8da118c9602eefcde5815ea73768f073.jpg";